/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getExportedFiles} from '../api'

 export const useQueryGetExportedFiles = createReactQueryHook('getExportedFiles', getExportedFiles)
